<template>
  <div>
    <v-row
      class="pa-0 ma-0"
      v-if="
        tripDetails &&
        tripDetails.order_details &&
        tripDetails.order_details.statistics &&
        Object.keys(tripDetails.order_details.statistics).length > 0
      "
    >
      <v-col
        v-for="(value, key, index) of tripDetails.order_details.statistics"
        :key="index"
        class="pa-2 mt-1"
        :class="
          index &&
          Object.keys(tripDetails.order_details.statistics).length - 1 == index
            ? 'pr-0'
            : index == 0
            ? 'pl-0'
            : ''
        "
      >
        <v-card class="px-5 py-3 rounded-lg mb-1" elevation="0" tile>
          <v-card-title class="d-flex justify-start pa-0">
            <span
              class="text-capitalize text-center text-caption"
              style="white-space: nowrap"
            >
              {{ key.replace(/_/g, "  ") }}
            </span>
          </v-card-title>
          <v-card-text class="d-flex justify-start pa-0">
            <v-btn small class="h-100 btn-box display-lg-none mr-3" depressed>
              <v-icon :color="getOrderStatusColor(key, true)" small>
                mdi-archive
              </v-icon>
            </v-btn>
            <h2 class="font-weight-bold d-flex align-center">
              {{ value }}
            </h2>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="rounded-lg pa-1" elevation="0">
      <v-row no-gutters>
        <v-col
          cols="3"
          :class="tripStatusColor(trip.status ? trip.status : '')"
          class="rounded-lg"
        >
          <v-row no-gutters>
            <v-col
              v-if="trip"
              cols="12"
              class="d-flex justify-space-between pa-3"
            >
              <h5 class="text-capitalize white--text">
                {{ trip.reference_number }}
              </h5>
              <v-chip small color="white">
                <span
                  v-if="
                    trip &&
                    trip.trip_details &&
                    trip.trip_details.verbose_status
                  "
                  ><b>{{ trip.trip_details.verbose_status }}</b>
                </span>
              </v-chip>
            </v-col>
            <v-col
              v-if="trip"
              cols="12"
              class="d-flex justify-space-between pb-1 pl-3"
            >
              <h5 class="white--text" v-if="trip">
                {{ orderModule.order }} Attempted<span class="mx-2">:</span>
                {{ trip.delivered_order }} /
                {{ trip.total_orders }}
              </h5>
              <h5
                v-if="trip.is_trip_delayed"
                class="white--text text-subtitle-1 font-weight-medium"
              >
                Delay: {{ trip.trip_delay_min }} min
              </h5>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="8" class="pa-0">
          <table style="width: 100%">
            <tr class="ma-0">
              <th>
                <h5>{{ tripModule.trip }} KPI</h5>
              </th>
              <th>
                <span class="text-caption font-weight-light">Start Time</span>
              </th>
              <th>
                <span class="text-caption font-weight-light">End Time</span>
              </th>
              <th>
                <span class="text-caption font-weight-light">Distance</span>
              </th>
              <th>
                <span class="text-caption font-weight-light">Duration</span>
              </th>
              <th>
                <span class="text-caption font-weight-light"
                  >Travelling Time</span
                >
              </th>
              <th>
                <span class="text-caption font-weight-light"
                  >Processing Time</span
                >
              </th>
            </tr>
            <tr>
              <th class="pt-2">
                <h5>Planned {{ tripModule.trip }}</h5>
              </th>
              <td
                v-show="trip && trip.planned_trip"
                v-for="(value, key, index) in trip.planned_trip"
                :key="index"
                class=""
              >
                <h5
                  class="d-flex justify-center text-caption font-weight-bold"
                  :class="
                    trip.status == 'active'
                      ? 'trip_active--text'
                      : trip.status == 'loading'
                      ? 'trip_loading--text'
                      : trip.status == 'paused'
                      ? 'trip_paused--text'
                      : 'black--text'
                  "
                >
                  {{ value }}
                </h5>
              </td>
            </tr>
            <tr>
              <th class="pt-2">
                <h5>Actual {{ tripModule.trip }}</h5>
              </th>
              <td
                v-show="trip && trip.actual_trip"
                v-for="(value, key, index) in trip.actual_trip"
                :key="index"
                class=""
              >
                <h5 class="d-flex justify-center text-caption">
                  {{ value ? value : "-" }}
                </h5>
              </td>
            </tr>
          </table>
        </v-col>
        <v-col cols="1" class="d-flex flex-column justify-center align-center">
          <v-btn
            class="rounded-lg mt-3"
            x-small
            depressed
            :class="isChatVisible ? 'primary' : ''"
            @click="changeMapSize('chat')"
          >
            <span
              class="text-capitalize"
              :class="isChatVisible ? 'white--text' : 'primary--text'"
            >
              Chat</span
            >
          </v-btn>
          <v-btn
            class="rounded-lg mt-3"
            :class="isLogsVisible ? 'primary' : ''"
            x-small
            depressed
            @click="changeMapSize('logs')"
          >
            <span
              class="text-capitalize"
              :class="isLogsVisible ? 'white--text' : 'primary--text'"
            >
              logs</span
            >
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-card elevation="0" class="pa-2 mt-3 rounded-lg">
      <div style="height: calc(100vh - 375px)" class="d-flex rounded-lg d-flex">
        <div style="width: 100%">
          <v-row no-gutters>
            <v-col :cols="mdColumn" class="position-relative">
              <GoogleMap
                :hasMapInfo="true"
                id="tripDetail"
                mapWidth="100%"
                mapHeight="calc(100vh - 377px)"
                ref="tripDetail"
                :clusterMarkers="true"
              >
                <template #mapInfo>
                  <MapInfo
                    legendType="trip"
                    ref="mapinfo"
                    @displayRoute="displayRoute"
                  />
                </template>
              </GoogleMap>
            </v-col>
          </v-row>
        </div>
        <div v-if="setMdColumn" style="width: 450px" class="expand-transation">
          <v-card class="" elevation="0" v-if="isLogsVisible">
            <v-card-title>
              <h5 class="text-caption mr-1 font-weight-bold">Logs</h5>
            </v-card-title>
            <v-card-text
              :style="`height: calc(100vh - 430px) `"
              class="overflow-y-auto"
              v-scroll:#trips-logs-target="onTripLogsScroll"
            >
              <Logs :logs="tripLogs" ref="viewTripLogs" />
            </v-card-text>
          </v-card>
          <v-divider v-show="isLogsVisible && isChatVisible"></v-divider>
        </div>

        <div style="position: relative">
          <div style="position: fixed; right: 3%; bottom: 7%; z-index: 2">
            <OperationChat
              ref="chat"
              v-model="isChatVisible"
              :tripObj="tripDetails"
            />
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { bus } from "@/main.js";
import { tripStatusColor } from "@/utils/functions.js";
import MapInfo from "@/components/BaseComponents/MapInfo.vue";
import Logs from "@/components/BaseComponents/Logs.vue";
import BaseLogs from "@/components/BaseComponents/BaseLogs.vue";
import OperationChat from "@/components/ModuleBasedComponents/Operation/OperationChat.vue";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import { orderModule, tripModule } from "@/utils/moduleMapping";
import { getOrderStatusColor } from "@/utils/functions";
export default {
  components: {
    MapInfo,
    Logs,
    OperationChat,
    BaseLogs,
    GoogleMap,
  },
  props: {
    trip: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      getOrderStatusColor,
      orderModule,
      tripModule,
      tripStatusColor,
      setMdColumn: false,
      mdColumn: 12,
      defaultSet: false,
      routeDetails: null,
      driverRoute: null,
      tripLogs: [],
      orderStatusCount: {
        total: 4,
        assigned: 3,
        picked_up: 0,
        out_for_delivery: 0,
        delivered: 1,
        partially_delivered: 0,
        not_delivered: 0,
      },
      isTripLogsScrollable: false,

      pageNo: 1,
      totalItems: 0,
      totalCount: 0,

      tripDetails: {},
      isChatVisible: false,
      isLogsVisible: false,
    };
  },
  computed: {
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
    totalPages() {
      return Math.ceil(this.totalCount / this.itemsPerPage);
    },
  },
  methods: {
    onTripLogsScroll(e) {
      let scroll =
        parseInt(e.target.scrollHeight) -
        parseInt(e.target.scrollTop + e.target.clientHeight);
      if (scroll < 4 && this.isTripLogsScrollable) {
        this.isTripLogsScrollable = false;
        this.getTripLogs();
      }
    },
    getSelectedTripDetails() {
      this.tripDetails = this.trip;
      if (this.$refs.tripDetail) {
        this.$refs.tripDetail.initMap;
        this.$refs.tripDetail.clearMarker();
        this.$refs.tripDetail.clearGeoJson();

        bus.$emit("showLoader", true);
        this.$api.operation
          .getTripRoute(this.tripDetails.id)
          .then((res) => {
            this.routeDetails = res.data;

            setTimeout(() => {
              this.$refs.tripDetail.setPlannedRoute(
                this.routeDetails.planned_route
              );

              this.$refs.tripDetail.setLocation(
                this.routeDetails.driver_last_location,
                "driver_live_location"
              );

              if (
                this.routeDetails &&
                this.routeDetails.actual_route &&
                this.routeDetails.actual_route.features &&
                this.routeDetails.actual_route.features.length != 0 &&
                this.routeDetails.actual_route.features[0].geometry &&
                this.routeDetails.actual_route.features[0].geometry.coordinates
              ) {
                this.driverRoute =
                  this.routeDetails.actual_route.features[0].geometry.coordinates;
                this.$refs.tripDetail.setDriverRoute(this.driverRoute);
                this.clearableRoute = true;
              }
            }, 100);

            bus.$emit("showLoader", false);
          })
          .catch((err) => {
            console.error(err);
            bus.$emit("showLoader", false);
          });
      }
    },

    getTripLogs(reload, params = {}) {
      // offset: reload ? 0 : this.tripLogs.length,
      params = {
        ...params,

        limit: "all",
      };
      bus.$emit("showLoader", true);
      if (reload || this.totalCount != this.tripLogs.length) {
        this.$api.newOperation
          .getTripLogs(params)
          .then((res) => {
            bus.$emit("showLoader", false);
            if (reload) {
              this.tripLogs = res.data;
            } else {
              this.tripLogs = [...this.tripLogs, ...res.data];
            }
            this.totalCount = res.count;
            if (this.totalCount != this.tripLogs.length) {
              this.isTripLogsScrollable = true;
            }
          })
          .catch((err) => {
            console.error(err);
            bus.$emit("showLoader", false);
          });
      }
    },
    displayRoute(route) {
      if (route && route.routeType == "planned") {
        if (route && route.display) {
          let tripRoute = { ...this.routeDetails.planned_route };
          delete tripRoute.pointers;
          this.$refs.tripDetail.setPlannedRoute(tripRoute);
        } else {
          this.$refs.tripDetail.clearGeoJson();
        }
      }
      if (route && route.routeType == "actual") {
        if (this.driverRoute && this.driverRoute.length > 0) {
          if (route && route.display) {
            this.$refs.tripDetail.setDriverRoute(this.driverRoute);
            this.clearableRoute = true;
          } else {
            if (this.clearableRoute) {
              this.$refs.tripDetail.setDriverRoute(null, true);
            }
          }
        }
      }
    },
    openChatBox() {
      if (this.isChatVisible) {
        this.isChatVisible = false;
        setTimeout(() => {
          this.isChatVisible = true;
        }, 100);
      }
    },
    changeMapSize(val) {
      if (val == "chat") {
        this.isChatVisible = !this.isChatVisible;
      } else {
        this.isLogsVisible = !this.isLogsVisible;
      }

      if (this.isLogsVisible) {
        this.setMdColumn = true;

        setTimeout(() => {
          this.getTripLogs(true, {
            trip: this.tripDetails.id,
          });
        }, 100);
      } else {
        this.setMdColumn = false;
      }
    },
  },
};
</script>

<style>
.expand-transation {
  transition: 5s;
}
</style>
